import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { NavigationEnd, NavigationStart, Router } from '@angular/router'
import { ScriptLoaderService } from '../_services/script-loader.service'
import { Helpers } from '../helpers'

declare let mApp: any
declare let mUtil: any
declare let mLayout: any
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
  templateUrl: './theme.component.html'
})
export class ThemeComponent implements OnInit {
  constructor (private _script: ScriptLoaderService, private _router: Router) {}
  public ngOnInit () {
    this._script
      .load(
        'body',
        'assets/vendors/base/vendors.bundle.js',
        'assets/demo/default/base/scripts.bundle.js'
      )
      .then((result) => {
        Helpers.setLoading(false)
      })
      .catch()
    this._router.events.subscribe((route) => {
      if (route instanceof NavigationStart) {
        try {
          mLayout.closeMobileAsideMenuOffcanvas()
          mLayout.closeMobileHorMenuOffcanvas()
          Helpers.setLoading(true);
          // hide visible popover
          ($('[data-toggle="m-popover"]') as any).popover('hide')
        } catch (e) {}
      }
      if (route instanceof NavigationEnd) {
        // init required js
        mApp.init()
        mUtil.init()
        Helpers.setLoading(false)
        // content m-wrapper animation
        const animation = 'm-animate-fade-in-up'
        $('.m-wrapper')
          .one(
            'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
            (e) => {
              $('.m-wrapper').removeClass(animation)
            }
          )
          .removeClass(animation)
          .addClass(animation)
      }
    })
  }
}
